import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue';
import PageNavigation from '@shared/components/PageNavigation.vue';
import LogoHorizontal from '@shared/components/LogoHorizontal.vue';
import LogoIcon from '@shared/components/LogoIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarNavigation',
  props: {
    isShowingHomepage: { type: Boolean }
  },
  setup(__props: any) {



const IS_OPS = process.env.VUE_APP_TYPE === 'ops';
const sidebarCollapsed = ref(false);

const onToggleSidebar = () => {
	sidebarCollapsed.value = !sidebarCollapsed.value;
	if (sidebarCollapsed.value) {
		localStorage.setItem('sidebarCollapsed', `true`);
	} else {
		localStorage.removeItem('sidebarCollapsed');
	}
};

onMounted(() => {
	if (localStorage.getItem('sidebarCollapsed')) sidebarCollapsed.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["sidebar py-4", {
			'sidebar-collapsed': sidebarCollapsed.value,
			'sidebar-open': !sidebarCollapsed.value,
			'sidebar--ops': IS_OPS,
		}])
  }, [
    _createVNode(_component_router_link, {
      to: { path: '/' },
      class: "sidebar__logo-container mt-1 mb-2"
    }, {
      default: _withCtx(() => [
        (sidebarCollapsed.value)
          ? (_openBlock(), _createBlock(LogoIcon, { key: 0 }))
          : (_openBlock(), _createBlock(LogoHorizontal, {
              key: 1,
              color: "white",
              "sub-color": "white",
              animated: true
            }))
      ]),
      _: 1
    }),
    _createVNode(PageNavigation, { "is-showing-homepage": _ctx.isShowingHomepage }, null, 8, ["is-showing-homepage"]),
    _createElementVNode("button", {
      type: "button",
      "aria-label": "toggle sidebar",
      class: "sidebar__toggle-btn",
      onClick: onToggleSidebar
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["bx", {
					'bx-chevron-left': !sidebarCollapsed.value,
					'bx-chevron-right': sidebarCollapsed.value,
				}])
      }, null, 2)
    ])
  ], 2))
}
}

})